import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Managment = {
	name: NAME,
	apiProvider,
	router,
};
